import React from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'
import { Submitting } from '../common/Submitting'
import { Input, Button } from '@foodsby/nutrient'

export const MAPS_SCRIPT_URL =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyBDH0Ysz12SLHmVyPo0nsisYMBY6kaUAcU&libraries=places&callback=loadGoogleMaps'

const getHighlightedText = (text, highlight) => {
  const highlightParts = highlight.split(' ')
  const parts = text.split(' ')

  return (
    <span>
      {parts &&
        parts.map((part, i) => (
          <span
            key={i}
            style={
              highlightParts &&
              highlightParts.some(
                highlight =>
                  highlight &&
                  part
                    .replace(/[^a-z0-9]/gi, '')
                    .toLowerCase()
                    .indexOf(
                      highlight.toLowerCase().replace(/[^a-z0-9]/gi, ''),
                    ) > -1,
              )
                ? { fontWeight: 'bold' }
                : {}
            }
          >
            {`${part} `}
          </span>
        ))}
    </span>
  )
}

class LocationSearchBox extends React.Component {
  state = { address: this.props.address || '', updated: false }

  handleChange = address => {
    this.setState({ address, updated: true })
  }

  handleSelect = address => {
    this.setState({ address })
    this.props.updateAddress(address)
  }

  static getDerivedStateFromProps(props, state) {
    if (props.address && props.address !== state.address && !state.updated) {
      return {
        address: props.address || '',
        updated: true,
      }
    }
    return null
  }

  render() {
    const {
      completeAccountToken,
      label,
      redirectOverride,
      search,
      showError,
      submitting,
    } = this.props
    return (
      <section>
        {label && <label htmlFor="searchbox">{label}</label>}
        <div className="searchWrapper">
          <div className="searchBox">
            <PlacesAutocomplete
              googleCallbackName="loadGoogleMaps"
              highlightFirstSuggestion
              onChange={this.handleChange}
              onError={() => {}}
              onSelect={this.handleSelect}
              value={this.state.address}
            >
              {({ getInputProps, getSuggestionItemProps, suggestions }) => {
                const className = suggestions.length
                  ? 'autocomplete-dropdown-container autocomplete-dropdown-container__active'
                  : 'autocomplete-dropdown-container'
                return (
                  <div className="autocomplete-root">
                    <div className="searchIcon">
                      <i className="icon-location" />
                    </div>
                    <Input
                      {...getInputProps({
                        placeholder: 'Find Your Building',
                        autoFocus: true,
                        id: 'searchbox',
                        onKeyDown: e => {
                          if (!suggestions.length && e.keyCode === 13) {
                            search(
                              this.state.address,
                              !redirectOverride,
                              null,
                              null,
                              completeAccountToken,
                            )
                          }
                        },
                      })}
                      tabIndex="6"
                    />
                    <div className={className}>
                      {suggestions.map((suggestion, i) => {
                        const className = suggestion.active
                          ? 'autocomplete-suggestion autocomplete-suggestion__active'
                          : 'autocomplete-suggestion'

                        return (
                          <div
                            key={i}
                            {...getSuggestionItemProps(suggestion, {
                              className,
                            })}
                          >
                            <span>
                              {getHighlightedText(
                                suggestion.description,
                                getInputProps().value,
                              )}
                            </span>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              }}
            </PlacesAutocomplete>
            {showError ? (
              <span className="error">
                Sorry, that&apos;s not a valid location.
              </span>
            ) : null}
          </div>
          <div className="searchButton">
            {submitting ? (
              <Submitting classNames="locationsearch-button" />
            ) : (
              <Button
                className="locationsearch-button"
                onClick={() =>
                  search(
                    this.state.address,
                    !redirectOverride,
                    null,
                    null,
                    completeAccountToken,
                  )
                }
                tabIndex="7"
                type="submit"
              >
                Search
              </Button>
            )}
          </div>
        </div>
      </section>
    )
  }
}

export default LocationSearchBox
